/*
 * „Neu!“ an neuen Produkten: das Ende im Browser nachprüfen.
 *
 * snippets/cm-new-flag rechnet in Liquid, also zu dem Zeitpunkt, zu dem Shopify die Seite baut. Kommt eine Seite aus
 * dem Cache, kann sie älter sein als das Ende des Schilds. Jedes Schild trägt deshalb sein Ende
 * (data-cm-new-until, Sekunden seit 1970); ist es vorbei, wird das Schild ausgeblendet und nicht mehr vorgelesen.
 * Ausblenden über ein Attribut, das nur die Sichtbarkeit nimmt — der Platz bleibt, nichts springt.
 */
(() => {
  const check = (scope) => {
    const now = Math.floor(Date.now() / 1000);
    for (const flag of (scope || document).querySelectorAll('[data-cm-new-until]:not([data-cm-new-expired])')) {
      const until = Number(flag.dataset.cmNewUntil);
      if (!Number.isFinite(until) || until <= 0 || now < until) continue;
      flag.setAttribute('data-cm-new-expired', '');
      flag.setAttribute('aria-hidden', 'true');
      // Die Produktkachel nennt das Schild in aria-labelledby; ein so benanntes Element wird trotz aria-hidden
      // vorgelesen. Ohne id greift der Verweis ins Leere und die Kachel heißt wieder nur wie das Produkt.
      flag.removeAttribute('id');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => check()); else check();
  // Listen, die nachgeladen werden (Filter, Sortierung, Suchvorschläge, Empfehlungen).
  document.addEventListener('shopify:section:load', (e) => check(e.target));
  if ('MutationObserver' in window) {
    // Ein Zeitgeber statt requestAnimationFrame: der läuft auch, solange der Tab nicht gezeichnet wird.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => { queued = false; check(); }, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
